import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad9ABlue13DRed = () => <CrossRoad coords="1709.000000, 1307.000000"/>;
export default CrossRoad9ABlue13DRed;
